import { Booking } from '@deliveries-app/models';
import { ProofOfDeliveryPayload } from '@deliveries-app/services';
import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from '../../Common/Button';
import InputText from '../../Common/InputText';
import Modal from '../../Common/Modal';
import { darkenColor } from '../../../utils/helpers';

interface DeliveredProps {
  booking: Booking;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ProofOfDeliveryPayload) => void;
}

const DeliveredModal = ({
  booking,
  open,
  onClose,
  onSubmit,
}: DeliveredProps) => {
  const signCanvas = useRef<SignatureCanvas>();
  const [name, setName] = useState('');
  const [note, setNote] = useState('');

  const handleSubmit = () => {
    const signature = signCanvas.current?.toDataURL('image/jpeg');
    const newSign = signature.replace('data:image/png;base64,', '');
    const changeStatusData: ProofOfDeliveryPayload = {
      status: 5,
      received_by: name,
      note: note,
      photo: newSign,
    };
    onSubmit(changeStatusData);
  };

  return (
    <Modal open={open} closeModal={onClose}>
      <div className="w-ful">
        <div className="flex w-full justify-start">
          <p className="text-lg font-semibold">Name</p>
        </div>
        <hr />
        <div className="mb-4 mt-3 w-full">
          <div className="mt-2">
            <div className="mt-1">
              <InputText
                type={'text'}
                name="name"
                isRequired={true}
                value={name}
                onChange={(val) => setName(val.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="flex w-full justify-start">
          <p className="text-lg font-semibold">Note</p>
        </div>
        <hr />
        <div className="mb-4 mt-3 w-full">
          <div className="mt-2">
            <div className="mt-1">
              <InputText
                type={'text'}
                name="note"
                isRequired={true}
                value={note}
                onChange={(val) => setNote(val.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 flex w-full justify-start">
          <p className="text-lg font-semibold">Signature</p>
        </div>
        <hr />
        <div className="w-full border border-gray-300">
          <SignatureCanvas
            ref={signCanvas}
            canvasProps={{
              width: 430,
              height: 150,
            }}
          />
        </div>
        <div className="mt-5 flex w-full justify-end">
          <Button
            className={`mr-1 rounded bg-gray-300 px-4 py-1 hover:bg-gray-400`}
            style={{
              color: 'white',
              transition: 'background-color 0.3s, box-shadow 0.3s',
            }}
            onFocus={(e) => {
              (
                e.currentTarget as HTMLButtonElement
              ).style.boxShadow = `0 0 0 3px ${booking.branch.branch_colour}`;
            }}
            onBlur={(e) => {
              (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none';
            }}
            type="button"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className={`mr-1 rounded bg-gray-300 px-4 py-1 hover:bg-gray-400`}
            style={{
              color: 'white',
              transition: 'background-color 0.3s, box-shadow 0.3s',
            }}
            onFocus={(e) => {
              (
                e.currentTarget as HTMLButtonElement
              ).style.boxShadow = `0 0 0 3px ${booking.branch.branch_colour}`;
            }}
            type="button"
            onClick={() => signCanvas?.current?.clear()}
          >
            Clear Signature
          </Button>
          <Button
            className={`ml-1 rounded px-4 py-1 text-white`}
            style={{
              backgroundColor: booking.branch.branch_colour,
              transition: 'background-color 0.3s',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor =
                darkenColor(booking.branch.branch_colour, 10);
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor =
                booking.branch.branch_colour;
            }}
            type="submit"
            onClick={() => handleSubmit()}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeliveredModal;
